import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
  Box,
  Link,
  IconButton
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import ImpressumIcon from 'assets/icons/Impressum_Datenschutz.png'

interface PrivacyComponentProps {
  open?: boolean;
  onClose?: () => void;
  children?: React.ReactNode;
  disableClose?: boolean;
}

const PrivacyComponent: React.FC<PrivacyComponentProps> = ({
  open,
  onClose,
  children,
  disableClose
}) => {
  const isDialog = typeof open === 'boolean';

  const content = (

    <Box display="flex" flexDirection="column" gap={2}>
      <Typography sx={{ fontSize: '1rem' }}>
        Christian Müller-Roterberg<br />
        Duisburger Straße 100<br />
        45407 Mülheim a.d.R.<br />
        Tel: 0208 88 254 -362<br />
        christian.mueller-roterberg@hs-ruhrwest.de
      </Typography>

      <Typography sx={{ fontSize: '1.25rem', fontWeight: 600, mt: 2 }}>
        Disclaimer – rechtliche Hinweise
      </Typography>
      <Typography sx={{ fontSize: '1.1rem', fontWeight: 600, mt: 2 }}>
        Auskunfts- und Widerrufsrecht
      </Typography>
      <Typography sx={{ textAlign: 'justify', mt: 1.5 }}>
        Sie haben jederzeit das Recht, sich unentgeltlich und unverzüglich über die zu Ihrer Person erhobenen Daten zu erkundigen. Ebenfalls können Sie Ihre Zustimmung zur Verwendung Ihrer angegebenen persönlichen Daten mit Wirkung für die Zukunft widerrufen. Hierfür wenden Sie sich bitte an den im Impressum angegebenen Diensteanbieter.
      </Typography>

      <Typography sx={{ fontSize: '1.1rem', fontWeight: 600, mt: 2 }}>
        Datenschutz (allgemein)
      </Typography>
      <Typography sx={{ textAlign: 'justify', mt: 1.5 }}>
        Beim Zugriff auf unsere Webseite werden automatisch allgemeine Informationen (sog. Server-Logfiles) erfasst. Diese beinhalten u.a. den von Ihnen verwendeten Webbrowser sowie Ihr Betriebssystem und Ihren Internet Service Provider. Diese Daten lassen keinerlei Rückschlüsse auf Ihre Person zu und werden von uns statistisch ausgewertet, um unseren Internetauftritt technisch und inhaltlich zu verbessern. Das Erfassen dieser Informationen ist notwendig, um den Inhalt der Webseite korrekt ausliefern zu können.
        <Typography sx={{ textAlign: 'justify', mt: 1.5 }}>
          Die Nutzung der Webseite ist grundsätzlich ohne Angabe personenbezogener Daten möglich. Soweit personenbezogene Daten (beispielsweise Name, Anschrift oder E-Mail-Adressen) erhoben werden, erfolgt dies, soweit möglich, stets auf freiwilliger Basis. Diese Daten werden ohne Ihre ausdrückliche Zustimmung nicht an Dritte weitergegeben.
        </Typography>
        <Typography sx={{ textAlign: 'justify', mt: 1.5 }}>
          Sofern ein Vertragsverhältnis begründet, inhaltlich ausgestaltet oder geändert werden soll oder Sie an uns eine Anfrage stellen, erheben und verwenden wir personenbezogene Daten von Ihnen, soweit dies zu diesem Zwecke erforderlich ist (Bestandsdaten). Wir erheben, verarbeiten und nutzen personenbezogene Daten soweit dies erforderlich ist, um Ihnen die Inanspruchnahme des Webangebots zu ermöglichen (Nutzungsdaten). Sämtliche personenbezogenen Daten werden nur solange gespeichert wie dies für den genannten Zweck (Bearbeitung Ihrer Anfrage oder Abwicklung eines Vertrags) erforderlich ist. Hierbei werden steuer- und handelsrechtliche Aufbewahrungsfristen von uns berücksichtigt. Auf Anordnung der zuständigen Stellen müssen wir im Einzelfall Auskunft über diese Daten (Bestandsdaten) erteilen, soweit dies für Zwecke der Strafverfolgung, zur Gefahrenabwehr, zur Erfüllung der gesetzlichen Aufgaben der Verfassungsschutzbehörden oder des Militärischen Abschirmdienstes oder zur Durchsetzung der Rechte am geistigen Eigentum erforderlich ist.
        </Typography>
        <Typography sx={{ textAlign: 'justify', mt: 1.5 }}></Typography>
        Wir weisen ausdrücklich darauf hin, dass die Datenübertragung im Internet (z. B. bei der Kommunikation per E-Mail) Sicherheitslücken aufweisen kann. Vor dem Zugriff auf Daten kann nicht lückenlos geschützt werden.
      </Typography>
      <Typography sx={{ textAlign: 'justify', mt: 1.5 }}>
        Die Nutzung von im Rahmen der Impressumspflicht veröffentlichten Kontaktdaten durch Dritte zur Übersendung von nicht ausdrücklich angeforderter Werbung und Informationsmaterialien wird hiermit ausdrücklich untersagt. Ausgenommen hiervon sind bestehende Geschäftsbeziehungen bzw. es liegt Ihnen eine entsprechende Einwilligung von uns vor.
      </Typography>
      <Typography sx={{ textAlign: 'justify', mt: 1.5 }}>
        Die Anbieter und alle auf dieser Website genannten Dritten behalten sich ausdrücklich rechtliche Schritte im Falle der unverlangten Zusendung von Werbeinformationen vor. Gleiches gilt für die kommerzielle Verwendung und Weitergabe der Daten.
      </Typography>

      <Typography sx={{ fontSize: '1.1rem', fontWeight: 600, mt: 2 }}>
        Google Analytics
      </Typography>
      <Typography sx={{ textAlign: 'justify', mt: 1.5 }}>
        Diese Website benutzt Google Analytics, einen Webanalysedienst der Google Inc. ("Google"), 1600 Amphitheatre Parkway, Mountain View, CA 94043, USA. Google Analytics verwendet sog. "Cookies" (Textdateien), die auf Ihrem Computer gespeichert werden und die eine Analyse der Benutzung der Website durch Sie ermöglichen. Die durch das Cookie erzeugten Informationen über Ihre Benutzung dieser Website werden in der Regel an einen Server von Google in den USA übertragen und dort gespeichert. Im Falle der Aktivierung der IP-Anonymisierung auf dieser Website, wird Ihre IP-Adresse von Google jedoch innerhalb von Mitgliedstaaten der Europäischen Union oder in anderen Vertragsstaaten des Abkommens über den Europäischen Wirtschaftsraum zuvor gekürzt. Nur in Ausnahmefällen wird die vollständige IP-Adresse an einen Server von Google in den USA übertragen und dort anonymisiert. Im Auftrag des Betreibers dieser Website wird Google diese Informationen benutzen, um Ihre Nutzung der Website auszuwerten, um Reports über die Websiteaktivitäten zusammenzustellen und um weitere mit der Websitenutzung und der Internetnutzung verbundene Dienstleistungen gegenüber dem Websitebetreiber zu erbringen. Die im Rahmen von Google Analytics von Ihrem Browser übermittelte IP-Adresse wird nicht mit anderen Daten von Google zusammengeführt.
      </Typography>
      <Typography sx={{ textAlign: 'justify', mt: 1.5 }}>
        Sie können die Speicherung der Cookies durch eine entsprechende Einstellung Ihrer Browser-Software verhindern; wir weisen Sie jedoch darauf hin, dass Sie in diesem Fall gegebenenfalls nicht sämtliche Funktionen dieser Website vollumfänglich nutzen können. Sie können darüber hinaus die Erfassung der durch das Cookie erzeugten und auf Ihre Nutzung der Website bezogenen Daten (inkl. Ihrer IP-Adresse) an Google sowie die Verarbeitung dieser Daten durch Google verhindern, indem sie das unter dem folgenden Link verfügbare Browser-Add-on herunterladen und installieren: http://tools.google.com/dlpage/gaoptout?hl=de. Das Browser-Add-on zur Deaktivierung von Google Analytics ist mit Chrome, Internet Explorer 8 bis 11, Safari, Firefox und Opera kompatibel.
      </Typography>
      <Typography sx={{ textAlign: 'justify', mt: 1.5 }}>
        Weitere Informationen zu Nutzungsbedingungen und Datenschutz finden Sie unter:{' '}
        <Link
          href="http://www.google.com/analytics/terms/de.html"
          target="_blank"
          rel="noopener noreferrer"
        >
          google.com/analytics/terms/de.html
        </Link>{' '}
        und{' '}
        <Link
          href="https://www.google.de/intl/de/policies/"
          target="_blank"
          rel="noopener noreferrer"
        >
          google.de/intl/de/policies/
        </Link>.
      </Typography>

      <Typography sx={{ fontSize: '1.25rem', fontWeight: 600, mt: 4 }}>
        Disclaimer (Haftungsausschluss)
      </Typography>

      <Typography sx={{ fontSize: '1.1rem', fontWeight: 600, mt: 2 }}>
        1. Haftung für Inhalte
      </Typography>
      <Typography sx={{ textAlign: 'justify', mt: 1.5 }}>
        Als Diensteanbieter sind wir gemäß § 7 Abs. 1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen. Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich. Bei Bekanntwerden von entsprechenden Rechtsverletzungen werden wir diese Inhalte umgehend entfernen.
      </Typography>

      <Typography sx={{ fontSize: '1.1rem', fontWeight: 600, mt: 2 }}>
        2. Haftung für Links
      </Typography>
      <Typography sx={{ textAlign: 'justify', mt: 1.5 }}>
        Diese Website enthält Links zu externen Webseiten Dritter, auf deren Inhalte kein Einfluss genommen werden kann. Deshalb kann für diese fremden Inhalte auch keine Gewähr übernommen werden. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich. Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung nicht erkennbar. Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne konkrete Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von Rechtsverletzungen werden derartige Links umgehend von dieser Website auf die rechtsverletzende Site entfernen.
      </Typography>

      <Typography sx={{ fontSize: '1.1rem', fontWeight: 600, mt: 2 }}>
        3. Urheberrecht
      </Typography>
      <Typography sx={{ textAlign: 'justify', mt: 1.5 }}>
        Die durch die Diensteanbieter, deren Mitarbeiter und beauftragte Dritte erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der vorherigen schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers. Downloads und Kopien dieser Seite sind nur für den privaten, nicht kommerziellen Gebrauch gestattet. Soweit die Inhalte auf dieser Seite nicht vom Betreiber erstellt wurden, werden die Urheberrechte Dritter beachtet. Insbesondere werden Inhalte Dritter als solche gekennzeichnet. Sollten Sie trotzdem auf eine Urheberrechtsverletzung aufmerksam werden, bitten wir um einen entsprechenden Hinweis. Bei Bekanntwerden von Rechtsverletzungen werden derartige Inhalte umgehend entfernen.
      </Typography>

      {children}
    </Box>
  );

if (!isDialog) {
  return (
    <Box>
      <Box display="flex" alignItems="center" gap={1} mb={2}>
        <img src={ImpressumIcon} alt="Impressum Icon" style={{ width: 60, height: 60 }} />
        <Typography sx={{ fontSize: '1.5rem', fontWeight: 700 }}>
          Impressum & Datenschutz
        </Typography>
      </Box>
      {content}
    </Box>
  );
}


  return (
    <Dialog
      open={open}
      onClose={(event, reason) => {
        if (disableClose && (reason === 'backdropClick' || reason === 'escapeKeyDown')) {
          return;
        }
        onClose?.();
      }}
      disableEscapeKeyDown={disableClose}
      maxWidth="md"
      fullWidth
      scroll="paper"
    >
      <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Box display="flex" alignItems="center" gap={1}>
          <img src={ImpressumIcon} alt="Impressum Icon" style={{ width: 60, height: 60 }} />
          <Typography sx={{ fontSize: '1.5rem', fontWeight: 700 }}>
            Impressum & Datenschutz
          </Typography>
        </Box>
        {!disableClose && (
          <IconButton onClick={onClose} aria-label="close">
            <CloseIcon />
          </IconButton>
        )}
      </DialogTitle>

      <DialogContent dividers>{content}</DialogContent>
    </Dialog>
  );
};

export default PrivacyComponent;
